export default "__VITE_ASSET__42fa9498__"